import { KpiBase } from "./kpiBase";

export class Kpi2View extends KpiBase {
  constructor(className, map, nodeRef) {
    super(className);
    this._nodeRef = nodeRef;
    this._map = map;
    this._r = 30;
    this._counter = 0;

    this._data = {};

    this._headerValue = swim.HtmlView.fromNode(this._wrap.querySelector('.value'));
    this._headerValue.text('--');

    this.connected();
  }

  connected() {
    this._link = this._nodeRef.downlinkMap().laneUri('vehicleCounts')
      .didUpdate(this.updateData.bind(this)).open();
  }

  updateData(k, v) {
    const key = k.stringValue();

    let slice = this._pie.getChildView(key);
    let data = this._data[key];
    if(!slice) {
      const legend = new swim.TextRunView(`${key}`).font(this._legendSize);
      slice = new swim.SliceView()
        .label('')
        .legend(legend)
        .tickRadius(`${this._r + this._counter + 3}%`)
        .outerRadius(`${this._r + this._counter}%`)
        .innerRadius(`${this._r - 15}%`)
        .value(1);

      slice.label().font(this._labelSize).textColor(swim.Color.black());
      this._pie.setChildView(key, slice);
      this._counter++;
      data = this._data[key] = {slice: slice, color: 'rgba(0,0,0,0)', dirty: true};
    }

    data.value = v.numberValue();
  }

  render() {
    for(const key in this._data) {
      this.sliceColor(key);
    }

    for(const key in this._data) {
      const value = this._data[key];
      this.updateSlice(key);
    }
  }

  updateSlice(key) {
    const data = this._data[key];
    const slice = data.slice;
    const tween = (data.value > 0)? this._tween : false;

    slice.value(data.value, tween);
    slice.label().text(`${data.value}`);
    this.updateTotal();

    if(data.dirty) {
      const color = (data.value > 0)? data.color : swim.Color.transparent();
      slice.sliceColor(color)
        .tickColor(color);

      slice.legend().textColor(color);
      slice.label().textColor( (data.value > 0)? swim.Color.black() : swim.Color.transparent());
    }

    data.dirty = false;
  }

  sliceColor(key) {
    let color = (key === 'With Events')? '#F9F070' : '#9c9d9f';

    // if(this._map.noTag || this._map.showCrush) {
    //   color = '#9c9d9f';
    // } else {
    //   color = '#F9F070';
    // }

    if(this._data[key].color !== color) {
      this._data[key].color = color;
      this._data[key].dirty = true;
    }
  }

  updateTotal() {
    let counter = 0;
    for(const key in this._data) {
      counter += this._data[key].value;
    }
    this._headerValue.text(`${counter}`);
  }

}
